import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import RealEstate from "../../images/property.png";
import grow from "../../images/grow.png";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { HiMiniChevronDown, HiMiniChevronUp } from "react-icons/hi2";
import { MdOutlineFileDownload } from "react-icons/md";
import axios from "axios";
import NoDataFound from "../../components/NoDataFound";
import ImageLoading from "../../components/ImageLoading";

function RealEstateAnalyzer({ id }) {
  const token = localStorage.getItem("token");
  const lender_id = localStorage.getItem("lender_uuid");

  const [holdingData, setHoldingData] = useState([
    "All Holding",
    "Broker 1",
    "Broker 2",
    "Broker 3",
    "Broker 4",
    "Broker 5",
  ]);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [holdingSelected, setHoldingSelected] = useState("All Holding");
  const [openHoldingMore, setOpenHoldingMore] = useState(false);
  const [more, setMore] = useState(false);
  const [expand, setExpand] = useState(false);
  const [expandAnalytics, setExpandAnalytics] = useState(false);
  const [holdingDetails, setHoldingDetails] = useState("");
  const [stocksData, setStocksData] = useState([1, 2, 3, 4, 5, 6]);
  const [showView, setShowView] = useState(false);
  const [showViewAnalytics, setShowViewAnalytics] = useState(false);

  const [recordArray, setRecordArray] = useState([]);
  const [noDownload, setNoDownload] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalArea, setTotalArea] = useState(0);

  const calculateTotalAmount = (res) => {
    let temp = 0;
    let temp1 = 0;
    res.map((item) => {
      let fixed = parseFloat(item.collateral_value);
      let fixed1 = parseFloat(item.area_in_sq_feet);
      temp = temp + fixed;
      temp1 = temp1 + fixed1;
    });
    setTotalPrice(temp);
    setTotalArea(temp1);
  };

  const fetchRecordId = (assetArray) => {
    let flagArray = [];
    assetArray.forEach((item) => {
      flagArray = [...flagArray, ...item.record_ids];
    });
    setRecordArray(flagArray);
  };

  const fetchAssetGateway = async () => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/asset_gateway`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res?.data?.asset_gateway?.real_estates?.length > 0) {
        fetchRecordId(res.data.asset_gateway.real_estates);
        setLoading(false);
      } else {
        setNoDownload(true);
      }
    } catch (error) {}
  };

  const ReDataHolding = async () => {
    setLoading(true);
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/real_estate_details?user_id=${id}`,
        method: "GET",
        headers: { Authorization: token, "Content-Type": "application/json" },
      };
      const res = await axios(options);
      if (res?.data === "Real Estate Data Not Found") {
        setHoldingDetails("");
        setNoData(true);
        setLoading(false);
      } else {
        setHoldingDetails(res.data);
        calculateTotalAmount(res.data);
        fetchAssetGateway();
        setNoData(false);
        setLoading(false);
      }
    } catch (error) {
      setHoldingDetails("");
      setNoData(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    ReDataHolding();
  }, []);

  function truncateText(text, maxLength) {
    if (text === null) return "---";
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }

  const handleExcelDownload = async (assetName) => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/download_as_excel`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          asset_name: assetName,
          record_ids: recordArray,
        },
      };
      const res = await axios(options);
      if (res.data.url.status) {
        const url = res.data.url.data;
        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {!noData && !loading && (
        <div className=" mt-4 w-full overflow-auto h-[calc(100vh-190px)]">
          <div className="flex flex-row justify-between gap-2">
            <div className="flex flex-col justify-between gap-3 w-[49.4%] h-full">
              <div
                className={`bg-white rounded-lg w-full p-3 ${
                  expand ? "h-fit" : "h-fit"
                }`}
              >
                <p className="text-[#262626] font-semibold text-base">
                  Real Estate Holding
                </p>
                <div
                  className={`${
                    expand && holdingDetails.length > 5
                      ? "overflow-y-scroll h-[60vh]"
                      : expand && holdingDetails.length <= 5
                      ? "overflow-y-scroll h-fit"
                      : !expand && holdingDetails.length > 3
                      ? "overflow-y-hidden h-[292px]"
                      : "overflow-y-hidden h-fit"
                  }`}
                >
                  {holdingDetails &&
                    holdingDetails.map((item) => {
                      return (
                        <div className="mt-4 flex flex-row justify-between items-center border border-solid border-[#E6EBED] p-3 rounded-lg hover:shadow-lg">
                          <img
                            src={RealEstate}
                            width="45"
                            height="45"
                            alt="hdfc"
                            className=""
                          />
                          <div className="flex flex-row items-center basis-[50%]">
                            <div className="flex flex-col justify-start items-start mr-auto ml-3 gap-2">
                              <p className="text-xs font-semibold text-[#262626]">
                                {item.pincode}, {item.street}, {item.city}
                              </p>
                              <div className="flex flex-row justify-start items-center gap-1">
                                <p className="text-xs font-medium text-[#262626]">
                                  {item.property_type}
                                </p>
                                {/* <HiMiniChevronDown color="#D30D00" size={"15px"} />
                                 <p className="text-xs font-medium text-[#D30D00]">
                                   -1.25 &#37;
                                 </p> */}
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col justify-start items-start mr-auto gap-1">
                            <p className="text-xs font-medium text-[#8B8B8B]">
                              Area (sq ft)
                            </p>
                            <p className="text-xs font-medium text-[#262626]">
                              {item.area_in_sq_feet}
                            </p>
                          </div>
                          <div className="flex flex-col justify-start items-start gap-1">
                            <p className="text-xs font-medium text-[#8B8B8B]">
                              Current Value
                            </p>
                            <p className="text-xs font-medium text-[#262626]">
                              {formatToIndianRupees(item.collateral_value) ||
                                "--"}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                </div>
                {holdingDetails && holdingDetails.length > 3 && (
                  <div className="flex flex-row justify-center items-center mt-4">
                    {expand ? (
                      <p
                        className="text-xs font-semibold text-[#262626] cursor-pointer"
                        onClick={() => setExpand(false)}
                      >
                        Less
                      </p>
                    ) : showView ? (
                      <p
                        className="text-xs font-semibold text-[#262626] cursor-pointer"
                        onClick={() => setExpand(true)}
                        onMouseOut={() => setShowView(false)}
                      >
                        View More
                      </p>
                    ) : (
                      <HiMiniChevronDown
                        className="cursor-pointer rounded-full border border-solid border-[#262626] animate-bounce"
                        color="#262626"
                        size={"25px"}
                        onMouseOver={() => setShowView(true)}
                      />
                    )}
                  </div>
                )}
              </div>
              <div className={`bg-white rounded-lg full p-3 h-[120px]`}>
                <p className="text-[#262626] font-semibold text-base">
                  Downloads
                </p>
                <div className="mt-4 flex flex-row justify-between items-center border border-solid border-[#E6EBED] p-3 rounded-lg">
                  <div className="flex flex-row justify-start items-center mr-auto ml-3">
                    <p className="text-xs font-semibold text-[#262626]">
                      Real Estate Analysis
                    </p>
                  </div>
                  <div className="flex flex-row justify-start items-start">
                    <button
                      onClick={() => {
                        handleExcelDownload("real_estates");
                      }}
                      className={`px-4 py-1 flex flex-row items-center gap-2 rounded bg-white text-xs font-semibold text-[#00394d] border border-solid border-[#00394D] cursor-pointer`}
                    >
                      <MdOutlineFileDownload size={"20px"} color="#00394d" />
                      Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className={`bg-white rounded-lg w-[49.4%] p-3 h-fit`}>
              <p className="text-[#262626] font-semibold text-base">
                Analytics
              </p>
              <div className="flex flex-row justify-between items-center gap-3 mt-4">
                <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
                  <div className="flex flex-col justify-start items-start gap-3">
                    <p className="text-xs font-bold text-[#262626]">
                      Total Real Estate Value
                    </p>
                    <p className="text-lg font-semibold text-[#00394D]">
                      {formatToIndianRupees(totalPrice) || "--"}
                    </p>
                  </div>
                  <IoMdInformationCircleOutline size={"20px"} color="#262626" />
                </div>
                <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
                  <div className="flex flex-col justify-start items-start gap-3">
                    <p className="text-xs font-bold text-[#262626]">
                      Number of Real Estates
                    </p>
                    <p className="text-lg font-semibold text-[#00394D]">
                      {holdingDetails && holdingDetails.length}
                    </p>
                  </div>
                  <IoMdInformationCircleOutline size={"20px"} color="#262626" />
                </div>
              </div>
              <div className="flex flex-row justify-between items-center gap-3 mt-4">
                <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
                  <div className="flex flex-col justify-start items-start gap-3">
                    <p className="text-xs font-bold text-[#262626]">
                      Total Area Holding{" "}
                      <span className="text-xs font-bold text-[#6F6F6F]">
                        (sq ft)
                      </span>
                    </p>
                    <p className="text-lg font-semibold text-[#00394D]">
                      {totalArea}
                    </p>
                  </div>
                  <IoMdInformationCircleOutline size={"20px"} color="#262626" />
                </div>
              </div>
              {/* <div
            className={`w-full mt-3 ${
              expandAnalytics
                ? "overflow-y-scroll h-[45vh]"
                : "overflow-y-hidden h-[205px]"
            }`}
          >
            <div className="flex flex-col justify-center items-center border border-solid border-[#E6EBED] p-3 rounded-lg mt-3">
              <div className="flex flex-row justify-between items-center w-full">
                <p className="text-xs font-bold text-[#262626]">LTV Ratio</p>
                <IoMdInformationCircleOutline size={"20px"} color="#262626" />
              </div>
              {stocksData.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`w-full flex flex-row justify-between items-center pt-3 ${
                      stocksData.length !== index + 1 &&
                      "border-b border-solid border-[#E6EBED] pb-3"
                    }`}
                  >
                    <img
                      src={bank}
                      width="45"
                      height="45"
                      alt="hdfc"
                      className=""
                    />
                    <div className="flex flex-row justify-center items-center mr-auto ml-3">
                      <p className="text-xs font-semibold text-[#262626]">
                        Parag Parikh Flexi Cap
                      </p>
                    </div>
                    <div className="flex flex-col justify-center items-end gap-1 text-right">
                      <p className="text-xs font-medium text-[#8B8B8B]">
                        LTV Ratio
                      </p>
                      <p className="text-xs font-medium text-[#262626]">
                        55&#37;
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div> */}
              {/* <div className="flex flex-row justify-center items-center mt-5">
            {expandAnalytics ? (
              <p
                className="text-xs font-semibold text-[#262626] cursor-pointer"
                onClick={() => setExpandAnalytics(false)}
              >
                Less
              </p>
            ) : showViewAnalytics ? (
              <p
                className="text-xs font-semibold text-[#262626] cursor-pointer"
                onClick={() => setExpandAnalytics(true)}
                onMouseOut={() => setShowViewAnalytics(false)}
              >
                View More
              </p>
            ) : (
              <HiMiniChevronDown
                className="cursor-pointer rounded-full border border-solid border-[#262626] animate-bounce"
                color="#262626"
                size={"25px"}
                onMouseOver={() => setShowViewAnalytics(true)}
              />
            )}
          </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default RealEstateAnalyzer;
